import React from 'react';
import { Row, Col, Jumbotron, Form } from 'react-bootstrap';

const PayloadResponse = (props) => {
	return (
		<Row className="enpoint-form">
			<Col sm={12}>
				<Jumbotron className="payload-area">
					<Row>
						<Col sm={12}>
							<Form.Group>
								<Form.Label>Payload</Form.Label>
								<Form.Control as="textarea" rows="16" readOnly value={JSON.stringify(props.payload, undefined, 4)}/>
							</Form.Group>
						</Col>
					</Row>
				</Jumbotron>
			</Col>
		</Row>
	);
}

export default PayloadResponse;